export enum ModelTreeLevelsEnum {
  Flat = 'Flat',
  FlatTime = 'FlatTime',
  Nested = 'Nested',
  NestedFlatTime = 'NestedFlatTime'
}
